import { useContext } from "react";
import { ToastContext } from "../toast-context/toast-context";
/** `useToast` is a simple hook which adds toasts to the stack */
export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error("sc-web-ui: useToast hook was called outside of ToastProvider context");
    }
    return context;
};
